import styled from 'styled-components';

const ApplicationBody = styled.div`
    overflow: auto;
    display: block;
    position: relative;
    min-height: calc(100vh - 64px);
`;

export default ApplicationBody;
